import Portal from "@app/shared/Portal";
import uniqueId from "lodash/uniqueId";
import { JSX, useMemo } from "react";

import Menu from "./menus";
import { QESButton } from "@app/shared/qes-standards";

interface AsideProps {
  onHamburgerClick: () => void;
  showAside: boolean;
}

const Aside = (props: AsideProps): JSX.Element => {
  const id = useMemo(() => uniqueId("stacked-menu-"), []);
  return (
    <aside className={`app-aside app-aside-expand-md app-aside-light${props.showAside ? " show" : ""}`}>
      <span className="aside-trademark">Quest Enterprise Services&reg; (QES&reg;)</span>
      <QESButton
        className={`hamburger hamburger-squeeze active${props.showAside ? " show" : ""} p-0`}
        data-toggle="aside"
        aria-label="Close Menu"
        onClick={props.onHamburgerClick}
        qesTestId="aside__close-menu"
        qesType="secondary"
      >
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </QESButton>
      <div className="aside-content">
        <header className="aside-header d-block d-md-none">
          {/* TODO: User Information */}
        </header>

        <div className="aside-menu">
          <nav id={id} className="stacked-menu">
            <Menu />
          </nav>
        </div>
      </div>
      {props.showAside && (<Portal hideBodyScroll={true}>
        <div className="aside-backdrop show" onClick={props.onHamburgerClick} />
      </Portal>)}
    </aside>
  );
};

export default Aside;
